export default {
    CLICK: 'CalendarElementClick',
};
